import type { MessageKey } from "./ru"

export const beMessages = {
  "common.loading": "Загрузка...",
  "common.error": "Памылка",
  "common.back": "Назад",
  "common.next": "Далей",
  "common.search": "Пошук",
  "auth.loginErrorTitle": "Памылка ўваходу",
  "auth.openViaTelegram": "Адкрыйце праграму праз Telegram",
  "auth.telegramRequired": "Праграму трэба адкрыць праз Telegram",
  "auth.authorizationError": "Памылка аўтарызацыі",
  "device.rotatePortrait": "Павярніце прыладу ў вертыкальнае становішча",
  "country.brazil": "Бразілія",
  "country.vietnam": "В'етнам",
  "country.egypt": "Егіпет",
  "country.india": "Індыя",
  "country.indonesia": "Інданезія",
  "country.iran": "Іран",
  "country.spain": "Іспанія",
  "country.italy": "Італія",
  "country.kazakhstan": "Казахстан",
  "country.colombia": "Калумбія",
  "country.malaysia": "Малайзія",
  "country.mexico": "Мексіка",
  "country.nigeria": "Нігерыя",
  "country.pakistan": "Пакістан",
  "country.russia": "Расія",
  "country.usa": "ЗША",
  "country.turkey": "Турцыя",
  "country.uzbekistan": "Узбекістан",
  "country.ukraine": "Украіна",
  "country.philippines": "Філіпіны",
  "countrySelection.chooseCountry": "Выберыце краіну",
  "countrySelection.openAria": "Выбраць краіну",
  "languageSelection.chooseLanguage": "Выберыце мову",
  "commercial.direction.autotrade": "Аўтарынак",
  "commercial.direction.insurance": "Страхаванне",
  "commercial.direction.pitstop": "Піт-стоп",
  "commercial.direction.techhelp": "Дапамога на дарозе",
  "commercial.searchLabel": "Пошук BeepApp",
  "commercial.cityPlaceholder": "Увядзіце горад",
  "commercial.emptyTitle": "Сёння прапаноў няма",
  "commercial.emptyLine1": "У вашым горадзе пакуль няма актыўных партнёраў BeepApp",
  "commercial.emptyLine2": "Мы ўжо працуем над іх пошукам і падключэннем",
  "commercial.emptyLine3": "Новыя прапановы з'явяцца тут аўтаматычна",
  "commercial.helperLine1": "Увядзіце свой горад, каб убачыць",
  "commercial.helperLine2": "даступныя прапановы",
  "commercial.partnerPrompt": "Хочаце стаць партнёрам BeepApp?",
  "commercial.apply": "Падаць заяўку",
  "main.admin": "Адмін",
  "main.garage": "Гараж",
  "main.signalSent": "Сігнал адпраўлены",
  "main.partnerInviteUnavailable": "Партнёрскае запрашэнне недаступнае",
  "main.enterPlate": "Увядзіце дзяржнумар",
  "main.searchError": "Памылка пошуку",
  "main.signalSendError": "Не ўдалося адправіць сігнал",
  "main.shareCardPrefix": "Картка нумара",
  "main.shareLinkError": "Не ўдалося падрыхтаваць спасылку",
  "main.searchByPlateAria": "Пошук па дзяржнумары",
  "main.russianPlateAria": "Расійскі дзяржнумар",
  "main.plateAria": "Дзяржнумар",
  "main.findPlateAria": "Знайсці нумар",
  "main.loadingVehicle": "Загрузка карткі нумара…",
  "main.leaveSignal": "Адправіць сігнал",
  "main.share": "Падзяліцца",
  "signalSelection.chooseType": "Выберыце тып сігналу",
  "signalSelection.category.attention": "Асабістыя",
  "signalSelection.category.road": "Дарожныя",
  "signalSelection.category.urgent": "Тэрміновыя",
  "signalSelection.chooseSignal": "Выберыце сігнал",
  "signalSelection.suggestOwn": "Прапануйце свой варыянт",
  "signalConfirmation.title": "Пацвердзіце сігнал",
  "signalConfirmation.plateHeading": "Праверце дзяржнумар",
  "signalConfirmation.signalHeading": "Праверце выбраны сігнал",
  "signalConfirmation.replyTitle": "Дазволіць адказ у Telegram",
  "signalConfirmation.replyBody": "Уключыце, каб уладальнік нумара мог\nнапісаць вам у Telegram. Адказ магчымы толькі калі\nў вас ёсць @username. Рашэнне адказваць застаецца\nза ўладальнікам нумара.",
  "signalConfirmation.consentText": "Пацвярджаю, што гэты сігнал адпавядае\nрэальнай сітуацыі і не з'яўляецца спамам\nабо ілжывым паведамленнем.",
  "signalConfirmation.warning": "Пасля адпраўкі сігнал\nнельга будзе змяніць",
  "signalConfirmation.sending": "Адпраўка…",
  "signalConfirmation.send": "Адправіць",
  "partner.loadingAria": "Загрузка",
  "partner.title": "Партнёрская праграма",
  "partner.offerLine1": "Атрымлівайце 30% з усіх плацяжоў бестэрмінова",
  "partner.offerLine2": "ад карыстальнікаў, якіх вы запрасілі ў BeepApp",
  "partner.offerLine3": "праз партнёрскую праграму Telegram",
  "partner.connectUnavailable": "Падключэнне стане даступным пасля наладжвання Telegram Affiliate Program.",
  "partner.connectTelegram": "Падключыць у Telegram",
  "partner.qrAria": "QR-код партнёрскай спасылкі",
  "partner.download": "Спампаваць",
  "partner.promoHeading": "Стварыце асабісты промакод",
  "partner.promoHelperLine1": "Промакод актывуе дадатковы год падпіскі",
  "partner.promoHelperLine2": "і дапамагае прыцягваць карыстальнікаў",
  "partner.promoAria": "Промакод",
  "partner.affiliateHeading": "Ваша партнёрская спасылка",
  "partner.affiliateHelper": "Захавайце спасылку, каб стварыць асабісты QR-код",
  "partner.affiliateAria": "Партнёрская спасылка",
  "partner.qrNoteLine1": "QR-код можна размясціць на аўтамабілі,",
  "partner.qrNoteLine2": "у сацсетках і рэкламных матэрыялах",
  "partner.save": "Захаваць",
  "partner.reset": "Скінуць",
  "partner.resetConfirm": "Скінуць захаваную партнёрскую спасылку? Промакод застанецца за вамі.",
  "partner.promoFormatError": "Промакод павінен змяшчаць ад 4 да 15 сімвалаў.",
  "partner.affiliateHostError": "Дазволены толькі спасылкі t.me або telegram.me.",
  "partner.affiliatePathError": "Спасылка не змяшчае шлях Telegram.",
  "partner.affiliateFormatError": "Некарэктная партнёрская спасылка.",
  "partner.loadError": "Памылка загрузкі",
  "partner.checkInputError": "Праверце ўведзеныя даныя",
  "garageActivation.promoInvalid": "Промакод несапраўдны",
  "garageActivation.plateOccupied": "Гэты дзяржнумар ужо прывязаны",
  "garageActivation.activateError": "Не ўдалося актываваць Гараж",
  "garageEntry.loadJournalError": "Не ўдалося загрузіць бартавы журнал",
  "garageEntry.loadStatusesError": "Не ўдалося загрузіць статусы",
  "garageEntry.activationSuccess": "Гараж паспяхова актываваны",
  "garageEntry.plateAttached": "Нумар прывязаны",
  "garageEntry.attachError": "Не ўдалося прывязаць нумар",
  "garageEntry.activationNote": "Актывуйце свой Гараж",
  "garageSheet.activationTitle": "Актывацыя Гаража",
  "garageSheet.plateHelper": "Увядзіце дзяржнумар аўтамабіля",
  "garageSheet.promoHelper": "У вас ёсць промакод?",
  "garageSheet.cleanBonusLine1": "Пасля актывацыі ў вас будзе 1 гадзіна",
  "garageSheet.cleanBonusLine2": "на бясплатны «Чысты старт»",
  "garageSheet.activationFor": "Актывацыя на",
  "garageSheet.cost": "Кошт",
  "garageSheet.ownerConsentLine1": "Пацвярджаю, што я ўладальнік",
  "garageSheet.ownerConsentLine2": "аўтамабіля з указаным",
  "garageSheet.ownerConsentLine3": "дзяржнумарам.",
  "garageSheet.processing": "Апрацоўка...",
  "garageSheet.attach": "Прывязаць",
  "garageSheet.pay": "Аплаціць",
  "garageLifecycle.cleanTitle": "Чысты старт",
  "garageLifecycle.deactivateTitle": "Дэактывацыя Гаража",
  "garageLifecycle.cleanWarningLine1": "Гісторыя нумара будзе выдалена",
  "garageLifecycle.cleanWarningLine2": "без магчымасці аднаўлення!",
  "garageLifecycle.deactivateWarningLine1": "Пасля дэактывацыі доступ да актыўных",
  "garageLifecycle.deactivateWarningLine2": "функцый Гаража спыніцца",
  "garageLifecycle.willBeDeleted": "БУДЗЕ ВЫДАЛЕНА",
  "garageLifecycle.cleanRemovedLine1": "• Усе запісы з Бартавога журнала",
  "garageLifecycle.cleanRemovedLine2": "• Гісторыя атрыманых сігналаў",
  "garageLifecycle.cleanRemovedLine3": "• Публічныя лічыльнікі сігналаў",
  "garageLifecycle.cleanRemovedLine4": "  у картцы нумара",
  "garageLifecycle.willRemain": "ЗАСТАНЕЦЦА",
  "garageLifecycle.cleanPreservedLine1": "• Прывязка нумара да Гаража",
  "garageLifecycle.cleanPreservedLine2": "• Рэшта тэрміну актывацыі",
  "garageLifecycle.cleanPreservedLine3": "• Выбраны статус нумара",
  "garageLifecycle.cleanPreservedLine4": "• Агульная колькасць праглядаў карткі нумара",
  "garageLifecycle.freeFirstHour": "Бясплатна на працягу першай гадзіны",
  "garageLifecycle.willBecomeUnavailable": "СТАНЕ НЕДАСТУПНЫМ",
  "garageLifecycle.deactivateRemovedLine1": "• Бартавы журнал",
  "garageLifecycle.deactivateRemovedLine2": "• Выбар і выкарыстанне статусу нумара",
  "garageLifecycle.deactivateRemovedLine3": "• Вы аўтаматычна пакінеце Аўтаклан",
  "garageLifecycle.deactivateRemovedLine4": "• Аўтарынак",
  "garageLifecycle.deactivateRemovedLine5": "• Страхаванне",
  "garageLifecycle.deactivateRemovedLine6": "• Піт-стоп",
  "garageLifecycle.deactivateRemovedLine7": "• Дапамога на дарозе",
  "garageLifecycle.deactivateRemovedLine8": "• Дзяржнумар будзе адвязаны ад Гаража",
  "garageLifecycle.willRemainAvailable": "ЗАСТАНЕЦЦА ДАСТУПНЫМ",
  "garageLifecycle.deactivatePreservedLine1": "• Спадарожнік",
  "garageLifecycle.deactivatePreservedLine2": "• Дыспетчар",
  "garageLifecycle.deactivatePreservedLine3": "• Пошук і прагляд дзяржнумара",
  "garageLifecycle.deactivatePreservedLine4": "  публічнай карткі аўтамабіля",
  "garageLifecycle.deactivatePreservedLine5": "• Магчымасць паўторна актываваць",
  "garageLifecycle.deactivatePreservedLine6": "  Гараж у любы момант",
  "garageLifecycle.cleanConsentLine1": "Пацвярджаю згоду на выдаленне",
  "garageLifecycle.cleanConsentLine2": "усёй гісторыі гэтага нумара",
  "garageLifecycle.cleanConsentLine3": "без магчымасці аднаўлення.",
  "garageLifecycle.deactivateConsentLine1": "Пацвярджаю дэактывацыю і",
  "garageLifecycle.deactivateConsentLine2": "спыненне доступу да ўсіх",
  "garageLifecycle.deactivateConsentLine3": "актыўных функцый Гаража.",
  "garageLifecycle.clean": "Ачысціць",
  "garageLifecycle.deactivate": "Дэактываваць",
} satisfies Record<MessageKey, string>
